// extracted by mini-css-extract-plugin
module.exports = {"firstLine":"Style_firstLine__3FsVj","shead":"Style_shead__2hiJN","sarea":"Style_sarea__WIjur","sbutt":"Style_sbutt__BJdui"};